import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/ui/header/header.component';
import { FooterComponent } from './components/ui/footer/footer.component';
import { MicrobiotaComponent } from './components/microbiota/microbiota.component';
import { ProbioticosComponent } from './components/probioticos/probioticos.component';
import { SaludDigestivaComponent } from './components/salud-digestiva/salud-digestiva.component';
import { PreguntasFrecuentesComponent } from './components/preguntas-frecuentes/preguntas-frecuentes.component';
import { ReferenciasComponent } from './components/referencias/referencias.component';
import { notFoundComponent } from './components/error/error-404.component';

// Routes
import { routedComponents } from "./app-routing.module";
import { AvisoLegalComponent } from './components/aviso-legal/aviso-legal.component';
import { AvisoPrivacidadComponent } from './components/aviso-privacidad/aviso-privacidad.component';
import { AvisoFarmacovigilanciaComponent } from './components/aviso-farmacovigilancia/aviso-farmacovigilancia.component';
import { ProductosComponent } from './components/productos/productos.component';
import { DiarreaComponent } from './components/diarrea/diarrea.component';
import { InflamacionComponent } from './components/inflamacion/inflamacion.component';
import { EstrenimientoComponent } from './components/estrenimiento/estrenimiento.component';
import { ColitisComponent } from './components/colitis/colitis.component';
import { FloraIntestinalComponent } from './components/flora-intestinal/flora-intestinal.component';
import { MapaSitioComponent } from './components/mapa-sitio/mapa-sitio.component';

import { SeoService } from './seo.services';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    MicrobiotaComponent,
    ProbioticosComponent,
    SaludDigestivaComponent,
    PreguntasFrecuentesComponent,
    ReferenciasComponent,
    AvisoLegalComponent,
    AvisoPrivacidadComponent,
    AvisoFarmacovigilanciaComponent,
    ProductosComponent,
    DiarreaComponent,
    InflamacionComponent,
    EstrenimientoComponent,
    ColitisComponent,
    FloraIntestinalComponent,
    MapaSitioComponent,
    CookiePolicyComponent,
    notFoundComponent
  ],
  imports: [
    BrowserModule,
    routedComponents,
  ],
  providers: [
    SeoService
    //{provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
